module.exports = __webpack_public_path__ + "img/back.5b4922a0.svg";